
import Vue from 'vue';
import PublicPortfolioAnnouncement from '~/components/partials/public-portfolio/PublicPortfolioAnnouncement/PublicPortfolioAnnouncement.vue';
import { ONBOARDING_TOOLTIP_NAME } from '~/components/partials/war-room-onboarding/constants';
import type { IAnnouncementFeature } from '~/components/common/AnnouncementModal/constants';
import { ANNOUNCEMENT_FEATURES } from '~/components/common/AnnouncementModal/constants';
import Modal from '~/components/common/Modal/Modal.vue';
import ChevronIcon from '~/assets/svg/chevron-left.vue.svg';
import CloseIcon from '~/assets/svg/close.vue.svg';

export default Vue.extend({
  name: 'AnnoucementModal',
  components: {
    PublicPortfolioAnnouncement,
    Modal,
    ChevronIcon,
    CloseIcon,
  },
  data(): { modalName: string; currentIndex: number } {
    return {
      modalName: this.$constants.dynamicModals.WAR_ROOM_ANNOUNCEMENT_MODAL,
      currentIndex: 0,
    };
  },
  computed: {
    visibleFeatures(): Array<IAnnouncementFeature> {
      const items: IAnnouncementFeature[] = ANNOUNCEMENT_FEATURES;

      if (!this.$auth.loggedIn || !this.$auth.user.admin) {
        return items.filter(item => !item.onlyForAdmins);
      }

      return items;
    },
    currentFeature(): IAnnouncementFeature | null {
      return this.showModal ? this.visibleFeatures[this.currentIndex] : null;
    },
    showModal(): boolean {
      return (
        !!this.$tooltip.isPresent(ONBOARDING_TOOLTIP_NAME) &&
        !!this.visibleFeatures.length &&
        this.visibleFeatures.some(feature => !this.$tooltip.isPresent(feature.tooltipName)) &&
        this.currentIndex > -1 &&
        this.currentIndex <= this.visibleFeatures.length - 1
      );
    },
  },
  mounted() {
    if (!this.$auth.loggedIn) return;

    this.handleModalVisibility();
  },
  methods: {
    handleModalVisibility(): void {
      if (
        this.$tooltip.isPresent(ONBOARDING_TOOLTIP_NAME) &&
        this.visibleFeatures.some(feature => !this.$tooltip.isPresent(feature.tooltipName)) &&
        this.$route.query.dynamic_modal !== this.modalName
      ) {
        this.$modal.showWithRoute({ custom: this.modalName });
      }
    },
    closeTooltips(): void {
      this.visibleFeatures.forEach(feature => this.$tooltip.close(feature.tooltipName));
    },
    handleClose(): void {
      this.$modal.hide(this.modalName);
    },
    goToNext(): void {
      if (this.currentIndex < this.visibleFeatures.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    },
    goToPrevious(): void {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.visibleFeatures.length - 1;
      }
    },
  },
});
